module.exports = __webpack_public_path__ + "img/Picture9.eb7a1319.png";